export const getRandomArrayElement = (array) =>
   array[Math.floor(Math.random() * array.length)];
